<div *ngIf="campaigns.length === 0" class="page-container">
  <div>Loading...</div>
</div>
<div *ngIf="campaigns.length > 0" class="page-container">
  <div class="page-title">Campaigns</div>
  <div class="button-container">
    <button class="site-button blue" (click)="showAddNewCampaign = true;">Add New Campaign</button>
    <button class="site-button blue" (click)="showUploadEmail = true;">Upload Email</button>
  </div>
  <div class="data-table campaign-table">
    <div class="header">Campaign ID</div>
    <div class="header">Created Date</div>
    <div class="header">Name</div>
    <div class="header">Brand</div>
    <div class="header">Creator</div>
    <div class="header">Agent</div>
    <ng-container *ngFor="let campaign of campaigns">
      <div><a [routerLink]="['/campaigns', campaign.id]">{{campaign.id!.substring(0,8)}}</a></div>
      <div>{{campaign.createdDate | date:"MM/dd/yyyy"}}</div>
      <div>{{campaign.name}}</div>
      <div>{{getBrandName(campaign.brandId)}}</div>
      <div>{{campaign.creatorName}}</div>
      <div>{{resolveUserId(campaign.agentId)}}</div>
    </ng-container>
</div>

<!-- <app-dialog [(visible)]="showAddNewCampaign">
  <div class="dialog-title">Add New Campaign</div>
  <div class="add-resource-form">
    <div class="input-label">Name</div>
    <div><input class="text-input" [(ngModel)]="newCampaign.name" id="name" title="name" type="text" /></div>
  </div>
  <div class="button-container">
    <button class="site-button blue" (click)="AddCampaign()">Add Campaign</button>
  </div>
</app-dialog> -->
